import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PersonValidationResponse from 'src/models/responseTypes/PersonValidationResponse';

export type PersonDataState = {
  personData: PersonValidationResponse;
};

export const initialState: PersonDataState = {
  personData: {
    isValidPerson: true,
    personExist: false,
    possibleIssue: null,
    personInnova: null,
  },
};

const personSlice = createSlice({
  name: 'personSlice',
  initialState,
  reducers: {
    overwritePerson: (
      _,
      action: PayloadAction<PersonDataState>,
    ): PersonDataState => {
      return action.payload;
    },
    updateSearchPerson: (
      state,
      action: PayloadAction<PersonValidationResponse>,
    ): void => {
      state.personData = action.payload;
    },
  },
});

export const { overwritePerson, updateSearchPerson } = personSlice.actions;

export default personSlice.reducer;
